import { render, staticRenderFns } from "./ArrowLeftBack.vue?vue&type=template&id=486a371d&scoped=true"
import script from "./ArrowLeftBack.vue?vue&type=script&lang=js"
export * from "./ArrowLeftBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a371d",
  null
  
)

export default component.exports